<template>
  <div class="search-form px-3">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <form
      @submit.prevent="onSubmit"
      @reset="onReset"
    >
      <contract-filter
        ref="contractFilter"
        :show-only-my-contracts-option="true"
        :user="user"
        @contract-set="setContract"
        @company-set="setCompany"
      />
      <div class="row nopads">
        <div class="col-sm-6 pt-1" style="margin-top: 1px">
            <contract-order-multiselect
                ref="orderFilter"
                :contract-ids="contract ?  [contract.id] : []"
                :single-mode="true"
                @orders-selected="setOrder"
            />
        </div>
        <div
          class="col-sm-6"
          style="padding-top: 6px"
        >
          <span class="search-title">{{ $t('work_time.person') }}</span>
          <multiselect
            v-model="selectedUsers"
            class="multiselect_routa"
            :placeholder="$t('work_time.select_person')"
            :deselect-label="$t('common.remove_selection')"
            :select-label="$t('common.select')"
            :close-on-select="false"
            :multiple="true"
            label="name"
            track-by="name"
            :searchable="true"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :options="users"
          >
            <template
              #singleLabel="props"
            >
              <span class="option__desc">
                <span class="option__title">{{ props.option.name }}</span>
              </span>
            </template>
            <template
              #option="props"
            >
              <div class="option__desc">
                <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
              </div>
            </template>
            <template #noResult>
              <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
              <span>{{ $t('common.no_results') }}</span>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="nopads">
          <div class="col-sm-6" style="padding-right: calc(0.5rem + 4px);">
            <span class="span-title">{{ $t('additional_cost.type') }}</span>
            <select
              id="type"
              v-model="type"
              class="form-select form-select-sm sm-3"
            >
              <option :value="null">
                {{ $t('orders.select_status') }}
              </option>
              <option
                v-for="option in getAdditionalCostType()"
                :key="option.value"
                :value="option.value"
              >
                {{ option.name }}
              </option>
            </select>
        </div>
        <div class="col-sm-6" style="padding-right: calc(0.5rem + 4px);">
            <span class="span-title">{{ $t('additional_cost.status') }}</span>
            <select
              id="status"
              v-model="status"
              class="form-select form-select-sm sm-3"
            >
              <option :value="null">
                {{ $t('orders.select_status') }}
              </option>
              <option
                v-for="option in getAdditionalCostStatus()"
                :key="option.value"
                :value="option.value"
              >
                {{ option.name }}
              </option>
            </select>
        </div>
      </div>
      <div class="col-sm-12 button-container">
          <button type="reset" class="btn btn-danger form-button">
              {{ $t('ins_report.clear') }}
          </button>
          <button type="submit" class="btn btn-primary form-button">
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </form>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import Multiselect from 'vue-multiselect'
import ContractFilter from "@/components/contract/ContractFilter";
import {orderMixin} from "@/components/mixins/OrderMixin";
import {additionalCostHelper} from "@/components/mixins/AdditionalCostMixin";
import ContractOrderMultiselect from "../order/ContractOrderMultiselect.vue";

export default {
    name: 'AdditionalCostSearch',
    components: {ContractOrderMultiselect, ContractFilter, Multiselect},
    mixins: [restApi, orderMixin, additionalCostHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            users: [],
            selectedUsers: [],
            contract: null,
            order: null,
            company: null,
            type: null,
            status: null
        }
    },
    mounted: function () {
        this.fetchUsers()
    },
    methods: {
        setOrder(order) {
            this.order = order
        },
        setContract: function (contract) {
            this.contract = contract
        },
        setCompany: function (company) {
            this.company = company
        },
        fetchUsers: function () {
            this.users = []
            this.restFetch(this.userUrl, this.handleUserResponse)
        },

        handleUserResponse: function (response) {
            if (response && response.data) {
                response.data.forEach(function (user) {
                    this.users.push({
                        value: user.id,
                        name: user.last_name + ', ' + user.first_name,
                        company: user.company.name,
                        email: user.email
                    })
                }, this)
            }
            this.loading = false
        },

        onSubmit: function () {
            let params = {}
            if (this.selectedUsers.length > 0) {
                let results = []
                this.selectedUsers.forEach(function (item) {
                    results.push(item.value)
                }, this)
                params.users = results
            }
            if (this.contract !== null) {
                params.contract = this.contract
            }
            if (this.order) {
                params.order = this.order.id
            }
            if (this.company !== null) {
                params.company = this.company
            }
            if (this.type) {
                params.type = this.type
            }
            if (this.status) {
                params.status = this.status
            }
            this.$emit('search', params)
        },

        onReset: function () {
            this.selectedUsers = []
            this.contract = null
            this.order = null
            this.company = null
            this.type = null
            this.status = null
        }
    }
}
</script>


